import React, { useEffect, useState } from "react";
import { project, projectAccess } from "../../../system/types/project/project";
import { initialProject } from "../../../system/initial/project";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { dispatch } from "../../../App";
import { actions } from "../../../redux";
import Icon from "@mdi/react";
import {mdiChevronLeft, mdiKeyLink, mdiKeyPlus} from "@mdi/js";
import { useTranslations } from "../../../hooks/useTranslations";

interface props {
    apiKeysStatus: string;
    setApiKeysStatus: React.Dispatch<React.SetStateAction<string>>;
}

const ListProjectKeys = (props: props) => {

    const { t } = useTranslations();

    const [projectData, setProjectData] = useState<project>(initialProject);
    const [listAccessKeys, setListAccessKeys] = useState<projectAccess[]>([]);

    useSelector((state: RootState) => {
        if (state.project.projectData !== projectData) {
            setProjectData(state.project.projectData);
        }
    });

    const closeList = () => {
        props.setApiKeysStatus('close');
    }

    const addProjectKey = () => {
        dispatch(actions.project.setPageCommand('editProjectKey'));
        dispatch(actions.project.setPageCommandId(''));
    };

    const editProjectKey = (key: string) => {
        dispatch(actions.project.setPageCommand('editProjectKey'));
        dispatch(actions.project.setPageCommandId(key));
    }

    useEffect(() => {
        setListAccessKeys(projectData.access);
    }, [projectData]);

    return (<>
        <div className="row mb-3 align-items-center">
            <span className="link" onClick={closeList}>
                <Icon path={mdiChevronLeft} size={1} /> {t('common.back')}
            </span>
        </div>
       <div className="row mb-3 align-items-center">
            <div className="col"><strong>{t('projects.apikeys')}</strong></div>
            <div className="col-auto"><button onClick={addProjectKey} className="btn btn-outline-primary"><Icon path={mdiKeyPlus} size={1} /></button></div>
        </div>
        {listAccessKeys.map((key) => (
            <div className="row mb-3">
                <div className="col-3">Domain</div>
                <div className="col">{ key.domain === '' ? '*' : key.domain }</div>
                <div className="col-auto"><button onClick={() => {
                    editProjectKey(key.token);
                }} className="btn btn-outline-primary"><Icon path={mdiKeyLink} size={1} /></button></div>
            </div>
        ))}
    </>);
}

export { ListProjectKeys };
